import React, { useContext, useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { submitEndorsement } from 'services/Api'
import { storageData } from 'services/Services'
import { HouseholdChangeContext } from '../HouseholdContext/HouseholdChangeContext'
import { useDriverHHM } from '../HouseholdContext/DriverHHMContext'
import { AddDriver_ValidateFields } from '../1_Household/Drivers/AddDriverForm/AddDriver_ValidateFields'
import { UpdateDriver_ValidateFields } from '../1_Household/Drivers/UpdateDriverForm/UpdateDriver_ValidateFields'
import { AddHhm_ValidateFields } from '../1_Household/HouseholdMembers/AddHhmForm/AddHhm_ValidateFields'
import { UpdateHhm_ValidateFields } from '../1_Household/HouseholdMembers/UpdateHhmForm/UpdateHhm_ValidateFields'
import { DriverAssignmentValidation } from 'components/StraightThroughAddressComp/DriverAssignmentValidation/DriverAssignmentValidation'

const HouseholdChangeBtnNav = () => {
    const navigate = useNavigate()
    const [isSubmitting, setIsSubmitting] = useState(false);
    const householdChangeContext = useContext(HouseholdChangeContext)
    const driverHHMContext = useDriverHHM()
    var householdChangeClass = householdChangeContext?.householdChangeClass
    var screen = window.location.pathname.split("/").pop()
    var householdForms = ["Add Driver", "Add Household Member", "Update Driver", "Update HHM"]

    const navigateBack = () => {
        // Household page
        if (screen == "household") {
            if (householdForms.includes(driverHHMContext?.driverHHM?.componentTracker)) {
                driverHHMContext?.clearDriverHHM();
            }
            else {
                // Return to home page
                householdChangeContext?.clear()
                window.location.href = "/home"
            }
        }
        else if (screen == "driver-assignment") {
            navigate("/endorsement/household")
        }
        else if (screen == "confirm") {
            if (driverAssignmentCheck(driverHHMContext)) {
                navigate("/endorsement/household/driver-assignment")
            }
            else {
                navigate("/endorsement/household")
            }
        }
    }

    // Next button component navigation
    const nextButtonNavigate = async () => {
        if (screen == "household") {
            setIsSubmitting(true);
            var validationList;
            var formVal = { ...handleForm(), componentTracker: driverHHMContext?.driverHHM?.componentTracker/*, requestedEffDate:""*/}

            // Validate Add Driver
            if (driverHHMContext?.driverHHM?.componentTracker === "Add Driver") {
                validationList = await AddDriver_ValidateFields({ context: householdChangeContext, session: formVal })
            }
            else if (driverHHMContext?.driverHHM?.componentTracker === "Update Driver") {
                validationList = await UpdateDriver_ValidateFields({ context: householdChangeContext, session: formVal })
                var formerVehicles = driverHHMContext?.driverHHM.vehicleInfo.vehiclesAtNewAddress
                const vehiclesAtNewAddress = formVal?.vehicleInfo?.vehiclesAtNewAddress?.map(
                    (x) => formerVehicles.filter(y => y.VIN == x)[0]
                )||[] //Adds whole vehicle object
                formVal = { ...formVal, userInfo: { ...driverHHMContext?.driverHHM?.userInfo }, vehicleInfo: { ...formVal.vehicleInfo, vehiclesAtNewAddress } }

                var storedDrivers = householdChangeContext["householdChangeClass"]?.driverAssignment?.drivers;
                if (storedDrivers && storedDrivers.length > 0) {
                    var driversCopy = storedDrivers;
                    
                    const updatedDriverIndex = storedDrivers.findIndex(driver => driver?.fullName === formVal?.userInfo?.firstName + " " + formVal?.userInfo?.lastName);
                    
                    if(updatedDriverIndex == -1){
                        var updatedInd = storedDrivers.findIndex(driver => (driver?.editType != "" && driver?.editType != null));
                        driversCopy[updatedInd] = formVal;
                    }
                    else{
                        driversCopy[updatedDriverIndex] = formVal;
                    }
                    
                }
            }
            else if (driverHHMContext?.driverHHM?.componentTracker === "Add Household Member") {
                validationList = await AddHhm_ValidateFields({ context: householdChangeContext, session: formVal })
            }
            else if (driverHHMContext?.driverHHM?.componentTracker === "Update HHM") {
                validationList = await UpdateHhm_ValidateFields({ context: householdChangeContext, session: formVal })
                formVal = { ...formVal, userInfo: { ...driverHHMContext?.driverHHM?.userInfo } }
            }
            else if (!driverHHMContext?.driverHHM?.componentTracker) {
                validationList = [{ title: "Oops!", message: 'Please add/update any drivers or household members on the policy.', valid: false }];
            }

            // Return validation modal if required fields not fulfilled
            if (validationList?.length > 0) {
                for (var i = 0; i < validationList.length; i++) {
                    householdChangeContext?.setValidationMsgToggle(validationList[i].title, validationList[i].message)
                    setIsSubmitting(false);
                    return;
                }
                return;
            }
            
            // console.log("dHHM Cont:", driverHHMContext);
            // console.log("Form Val:", formVal);
            formVal = {
                ...formVal,
                driverInfo: {
                    ...(formVal?.driverInfo||{}) ,
                    principalStatus: driverHHMContext?.driverHHM?.driverInfo?.principalStatus
                }
            }
            // console.log("Form Val 2:", formVal);
            driverHHMContext.setDriverHHM(formVal);
            
            
            var householdChangeClassCopy = driverHHMContext?.SaveFormToClass(householdChangeClass, formVal);
            
            if(driverHHMContext?.driverHHM?.componentTracker === "Update Driver"){
                householdChangeClassCopy.driverAssignment.drivers = driversCopy;
            }

            // Save to class
            householdChangeContext?.setHouseholdChangeClass({ ...householdChangeClassCopy })
            storageData.setItem("HouseholdChangeClass", JSON.stringify(householdChangeClassCopy))
            setIsSubmitting(false);

            // Redirect to driver assignment if added any new drivers (includes converting hhm to driver)
            if (driverAssignmentCheck(driverHHMContext)) {
                var storedDrivers = storageData.getItem("storedDrivers")
                householdChangeClassCopy.driverAssignment.drivers = JSON.parse(storedDrivers)
                householdChangeContext?.setHouseholdChangeClass({ ...householdChangeClassCopy })
                storageData.setItem("HouseholdChangeClass", JSON.stringify(householdChangeClassCopy))
                navigate("/endorsement/household/driver-assignment")
            }
            else {
                navigate("/endorsement/household/confirm")
            }
        }
        else if (screen === "driver-assignment") {
            // Validate driver-assignment page
            var validationList = await DriverAssignmentValidation({
                vehicles: householdChangeContext?.householdChangeClass?.driverAssignment?.vehicles,
                drivers: householdChangeContext?.householdChangeClass?.driverAssignment?.drivers
            });

            if (validationList?.length > 0) {
                for (var i = 0; i < validationList.length; i++) {
                    householdChangeContext?.setValidationMsgToggle(validationList[i].title, validationList[i].message)
                    setIsSubmitting(false);
                    return;
                }
                return;
            }

            // var formVal = { ...handleForm(), componentTracker: driverHHMContext?.driverHHM?.componentTracker }
            // formVal = {
            //     ...formVal,
            //     driverInfo: {
            //         ...(formVal?.driverInfo||{}),
            //         principalStatus: driverHHMContext?.driverHHM?.driverInfo?.principalStatus
            //     }
            // }
            // driverHHMContext.setDriverHHM(formVal);

            // Save to class
            if (householdChangeClass.driverAssignment.drivers.length<=householdChangeClass.driverAssignment.vehicles.length){
                householdChangeClass.driverAssignment.drivers[householdChangeClass.driverAssignment.drivers.length-1].driverInfo.principalStatus = "Principal";
            }
            else{
                householdChangeClass.driverAssignment.drivers.forEach(driver => {
                    const hasMatchingVehicle = householdChangeClass.driverAssignment.vehicles.some(vehicle =>
                        vehicle.driverDLN === driver?.driverInfo?.licenseNumber || vehicle.driverDLN === driver?.licenseNum
                    );
                    if(driver?.currStatus){
                        driver.currStatus = hasMatchingVehicle ? "Principal" : "Occasional";
                    }
                    else{
                        driver.driverInfo.principalStatus = hasMatchingVehicle ? "Principal" : "Occasional";
                    }
                });
            }

            var householdChangeClassCopy = householdChangeClass;
            householdChangeContext?.setHouseholdChangeClass({ ...householdChangeClassCopy })
            storageData.setItem("HouseholdChangeClass", JSON.stringify(householdChangeClassCopy))

            navigate("/endorsement/household/confirm")
        }
        else if (screen === "confirm") {
            setIsSubmitting(true);

            if (!householdChangeContext?.householdChangeClass?.confirmation) {
                householdChangeContext.setValidationMsgToggle("Oops!", "Please certify that the answers to the questions listed in the change are true and accurate to the best of your knowledge to submit your request.")
                setIsSubmitting(false);
                return;
            }

            // Send endorsement class to backend
            var req = {
                "requestType": "Household Change",
                "classRequest": storageData.getItem("HouseholdChangeClass")
            }
            setIsSubmitting(true);
            householdChangeContext?.setSubmissionLoad(true); // Display spinner and hide nav buttons

            // Api call to send data
            try {
                const response = await submitEndorsement(req);
                storageData.setItem("responseData", JSON.stringify(response.data));
                redirectWithRemoves(response.data?.requestStatus)
            } catch (error) {
                console.error("Error submitting endorsement:", error);
                householdChangeContext.setSubmitEndorsementResponse({ error: true, message: "An error occurred while submitting the endorsement." });
            } finally {
                setIsSubmitting(false);
                householdChangeContext?.setSubmissionLoad(false); // Hide spinner and display nav buttons
            }

            setIsSubmitting(false);
            // navigate("/endorsement/household/household-summary")
        }
    }

    // Removes last 2 pages from history stack to allow back button to home
    const redirectWithRemoves = (status) => {
        window.history.pushState(null, null, window.location.href);
        window.history.go(-2);
        window.history.replaceState(null, null, window.location.href);

        if (status == "Failed") {
            window.location.replace('/endorsement/household/household-fail')
        }
        else if (status == "Blocked") {
            window.location.replace('/endorsement/household/household-block')
        }
        else {
            window.location.replace('/endorsement/household/household-summary');
        }
    }

    return (
        <>
            <div className="mt-2 mb-3">
                <div>
                    {!isSubmitting &&
                        <>
                            {/* Back Button */}
                            <button type="button" className="btn btn-default editCancelBtn" onClick={navigateBack}>
                                BACK
                            </button>
                            {/* Continue Button */}
                            <button type="submit" className="btn btn-primary-grad right pull-right editCancelBtn" onClick={nextButtonNavigate}>
                                {screen == "confirm" ? "SUBMIT" : "NEXT"}
                            </button>
                        </>
                    }
                    {/* Spinner for retrieving vehicle info from vin */}
                    {isSubmitting &&
                        <div className="text-center">
                            <Spinner animation="border" />
                        </div>
                    }

                </div>
            </div>
        </>
    )
}

const handleForm = () => {
    const formValues = {};
    // Get all form elements (including those missing from FormData)
    document.querySelectorAll("input, select, textarea").forEach(input => {
        if (input.type === "checkbox") {
            formValues[input.name] = [...(formValues[input.name] || []), ...(input.checked ? [input.value] : [])];
        } else if (input.type === "radio") {
            if (!formValues[input.name]) {
                formValues[input.name] = (input.checked) ? input.value : ""; // Empty if no radio is selected
            }
        } else {
            formValues[input.name] = input.value || "";
        }
    });
    const formValuesReformatted = nestObject(formValues)
    return formValuesReformatted
}

function nestObject(obj) {
    let result = {};

    for (let key in obj) {
        if (key.includes("_")) {
            let [parent, child] = key.split("_");

            if (!result[parent]) {
                result[parent] = {};
            }

            result[parent][child] = obj[key];
        } else {
            result[key] = obj[key];
        }
    }

    return result;
}

const driverAssignmentCheck = (driverHHMContext) => {
    // Added driver form completed
    if (driverHHMContext?.driverHHM?.componentTracker === "Add Driver") return true;
    // Added household member as a driver
    else if (driverHHMContext?.driverHHM?.componentTracker === "Add Household Member" &&
        driverHHMContext?.calculateAge(driverHHMContext?.driverHHM?.userInfo?.dobMonth, driverHHMContext?.driverHHM?.userInfo?.dobDay, driverHHMContext?.driverHHM?.userInfo?.dobYear) >= 16 &&
        driverHHMContext?.driverHHM?.driverInfo?.ownInsurance === "0")
        return true;
    // Updated household member "As a Driver"
    else if (driverHHMContext?.driverHHM?.componentTracker === "Update HHM" && driverHHMContext?.driverHHM?.editType === "Add as driver on policy.") return true;
    else return false;
}

export default HouseholdChangeBtnNav